/*import React, { useState, useEffect } from "react";
import Table from 'react-bootstrap/Table';
import UserService from "../services/user.service";
import AdminService from "../services/admin.service";
import EventBus from "../common/EventBus";

const BoardAdmin = () => {
  const [content, setContent] = useState("");
  const [users, setUsers] = useState([]);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    UserService.getAdminBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );

    AdminService.getUsers().then(
      (response) => {
        const res = response.data;
        setUsers(res.users);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );

    AdminService.getMessages().then(
      (response) => {
        const res = response.data;
        console.log(res)
        setMsgs(res.posts);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    <div className="container" style={{ height: "500px" }}>
      <header className="jumbotron">
        <h3>{content}</h3>
        <h1>Panel admin</h1>
        <Table responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  users.length > 0 && users.map((user, index) => 
                  <tr key={index}>
                      <td>{user.id}</td>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.authorized}</td>
                    </tr>
                  )
                }
              </tbody>
          </Table>

          <Table responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Mensaje</th>
                  <th>Creado</th>
                </tr>
              </thead>
              <tbody>
                {
                  msgs.length > 0 && msgs.map((msg, index) => 
                    <tr key={index}>
                      <td>{msg.id}</td>
                      <td>{msg.firstname}</td>
                      <td>{msg.lastname}</td>
                      <td>{msg.email}</td>
                      <td>{msg.phone}</td>
                      <td>{msg.message}</td>
                      <td>{msg.created_at}</td>
                    </tr>
                  )
                }
              </tbody>
          </Table>
    </header>
    </div>
  );
};

export default BoardAdmin;*/

import React, { useState, useEffect } from "react";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import EventBus from "../../common/EventBus";

import { MessageTable } from "./Messages/MessageTable";
import { UserTable } from "./Users/UserTable";

const BoardAdmin = () => {
  const [content, setContent] = useState("");
  const [users, setUsers] = useState([]);
  const [msgs, setMsgs] = useState([]);
  //const [loading, setLoading] = useState(true);

  useEffect(() => {
    UserService.getAdminBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );

    AdminService.getUsers().then(
      (response) => {
        const res = response.data;
        console.log(res)
        setUsers(res.users);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );

    AdminService.getMessages().then(
      (response) => {
        const res = response.data;
        console.log(res)
        setMsgs(res.posts);
        //setLoading(false);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    <div className="container" style={{ height: "600px" }}>
      <header className="jumbotron">
        <h3>{content}</h3>
        <h1>Panel admin</h1>


          <UserTable data={users}/>

          <MessageTable data={msgs}/>

          

    </header>
    </div>
  );
};

export default BoardAdmin;
